import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";
import AuthValidation from "../../validation/AuthValidation";

export class EmailVerificationRequest implements IRequestModel {

    constructor(emailVerifKey: string) {
        this.email_verif_key = emailVerifKey;
    }

    uri: string = "auth/email-verification";
    method: HttpMethod = HttpMethod.POST;

    email_verif_key: string;

    isValid(): ValidationResponse {
        return AuthValidation.VerifKeyValid(this.email_verif_key, "Email Verification Key");
    }
}